import { labelsEn } from './labels-en';
export const labelsFr = {
  ...labelsEn,
  title: 'Étiquettes et marquage',
  subtitle: 'Étiquettes multilingues versionnées issues de données produit approuvées.',
  active: 'Actif',
  inactive: 'Inactif',
  autoReleased: 'Dernière version approuvée',
  help: { open: 'Ouvrir l’aide sur les étiquettes' },
  tabs: {
    templates: 'Modèles',
    formats: 'Formats',
    prints: 'Historique d’impression',
    design: 'Conception',
    previewPrint: 'Aperçu et impression',
  },
  templates: {
    title: 'Modèles d’étiquettes',
    description:
      'Le mode étiquette réutilise le concepteur PDF central et fige chaque version approuvée.',
    create: 'Nouveau modèle',
    createDescription: 'Commencez avec un format physique validé et une mise en page initiale.',
  },
  formats: {
    title: 'Formats d’étiquettes',
    description: 'Configurez feuilles, rouleaux, grilles, marges et espacements en millimètres.',
    create: 'Nouveau format',
    edit: 'Modifier le format',
  },
  prints: {
    title: 'Historique d’impression',
    description: 'Preuves immuables des tests, productions et réimpressions dans la GED.',
  },
  designer: {
    subtitle: 'Version de modèle {{version}}',
    elements: 'Éléments',
    canvas: 'Zone d’étiquette',
    inspector: 'Propriétés',
    selectElement: 'Sélectionnez un élément à modifier.',
  },
  preview: {
    title: 'Instantané des données',
    description:
      'Sélectionnez des données ERP réelles. Le serveur valide et rend le même instantané que celui utilisé pour l’impression.',
    legalTitle: 'Contrôle requis',
    legalWarning:
      'Les déclarations et mentions légales doivent être contrôlées et explicitement approuvées par du personnel qualifié avant toute utilisation contraignante.',
    pdf: 'Aperçu PDF côté serveur',
    empty: 'Sélectionnez les données et générez un aperçu.',
  },
  fields: {
    ...labelsEn.fields,
    name: 'Nom',
    description: 'Description',
    mediaType: 'Type de support',
    active: 'Actif',
    pageWidthMm: 'Largeur de page (mm)',
    pageHeightMm: 'Hauteur de page (mm)',
    labelWidthMm: 'Largeur d’étiquette (mm)',
    labelHeightMm: 'Hauteur d’étiquette (mm)',
    columns: 'Colonnes',
    rows: 'Lignes',
    marginLeftMm: 'Marge gauche (mm)',
    marginTopMm: 'Marge supérieure (mm)',
    horizontalGapMm: 'Espacement horizontal (mm)',
    verticalGapMm: 'Espacement vertical (mm)',
    format: 'Format',
    text: 'Texte',
    dynamicField: 'Champ de données dynamique',
    analysisParameter: 'Clé du paramètre d’analyse',
    symbology: 'Symbologie du code-barres',
    valueTemplate: 'Modèle de valeur',
    gs1Segments: 'Segments GS1',
    gs1Hint: 'Format : AI:source:longueur fixe, ex. 01:product.number:14, 10:batch.number',
    xMm: 'X (mm)',
    yMm: 'Y (mm)',
    widthMm: 'Largeur (mm)',
    heightMm: 'Hauteur (mm)',
    rotation: 'Rotation',
    fontSize: 'Taille de police (pt)',
    bold: 'Gras',
    product: 'Article',
    batch: 'Lot',
    productionOrder: 'Ordre de fabrication',
    declaration: 'Déclaration',
    analysis: 'Analyse / nutrition',
    quantity: 'Quantité',
    unit: 'Unité',
    copies: 'Exemplaires',
    reason: 'Motif',
    note: 'Note de contrôle',
    languages: 'Langues',
  },
  columns: {
    ...labelsEn.columns,
    name: 'Nom',
    version: 'Version',
    format: 'Format',
    status: 'Statut',
    updated: 'Modifié',
    page: 'Page',
    grid: 'Grille',
    number: 'N° d’impression',
    product: 'Article / lot',
    template: 'Modèle',
    kind: 'Type',
    created: 'Créé',
    actions: 'Actions',
  },
  media: { SHEET: 'Feuille', ROLL: 'Rouleau' },
  versionStatuses: {
    DRAFT: 'Brouillon',
    IN_REVIEW: 'En contrôle',
    APPROVED: 'Approuvé',
    ARCHIVED: 'Archivé',
  },
  printKinds: {
    TEST: 'Test d’impression',
    PRODUCTION: 'Impression production',
    REPRINT: 'Réimpression',
  },
  printStatuses: { PENDING: 'Traitement', READY: 'Prêt', FAILED: 'Échec' },
  elementTypes: {
    TEXT: 'Texte',
    DYNAMIC_TEXT: 'Texte dynamique',
    BARCODE: 'Code-barres',
    QR_CODE: 'Code QR',
    LINE: 'Ligne',
    BOX: 'Cadre',
  },
  dynamicFields: {
    product: {
      number: 'Numéro d’article',
      ean: 'EAN / GTIN',
      name: 'Désignation de l’article',
      externalName: 'Désignation externe',
      declarationName: 'Désignation déclarative',
    },
    declaration: {
      productName: 'Dénomination légale',
      ingredients: 'Liste des ingrédients',
      allergens: 'Allergènes',
      additives: 'Additifs',
      warnings: 'Avertissements',
    },
    nutrition: { summary: 'Tableau nutritionnel' },
    analysis: { value: 'Valeur d’analyse' },
    batch: {
      number: 'Numéro de lot',
      bestBeforeDate: 'Date de durabilité minimale',
      expiryDate: 'Date limite de consommation',
      productionDate: 'Date de production',
    },
    productionOrder: { number: 'Numéro d’ordre de fabrication' },
    quantity: { value: 'Quantité', unit: 'Unité' },
    storage: { instructions: 'Conditions de conservation' },
  },
  actions: {
    ...labelsEn.actions,
    addElement: 'Ajouter un élément',
    moveUp: 'Monter',
    moveDown: 'Descendre',
    newVersion: 'Nouvelle version',
    submit: 'Soumettre',
    approve: 'Approuver',
    archive: 'Archiver',
    preview: 'Aperçu',
    testPrint: 'Test',
    productionPrint: 'Impression production',
    download: 'Ouvrir le PDF',
    reprint: 'Réimprimer',
  },
  transition: {
    submit: {
      title: 'Soumettre au contrôle',
      description: 'La mise en page est verrouillée pendant le contrôle.',
    },
    approve: {
      title: 'Approuver l’étiquette',
      description:
        'L’approbation à quatre yeux fige la version pour les impressions de production.',
    },
    archive: {
      title: 'Archiver la version',
      description: 'Les versions archivées et leurs preuves d’impression restent immuables.',
    },
  },
  copy: {
    title: 'Créer une nouvelle version',
    description: 'La version sélectionnée est copiée dans un nouveau brouillon modifiable.',
  },
  reprint: {
    title: 'Réimpression motivée',
    description:
      'La version historique et l’instantané des données sont réutilisés à l’identique. Indiquez le motif de la nouvelle impression.',
  },
  messages: {
    ...labelsEn.messages,
    invalid: 'Vérifiez les données saisies.',
    formatSaved: 'Le format a été enregistré.',
    templateCreated: 'Le modèle a été créé.',
    saved: 'Le brouillon a été enregistré.',
    submit: 'La version a été soumise.',
    approve: 'La version a été approuvée.',
    archive: 'La version a été archivée.',
    versionCreated: 'Une nouvelle version brouillon a été créée.',
    printCreated: 'L’impression {{number}} a été générée.',
    reprintCreated: 'La réimpression a été enregistrée.',
    productRequired: 'Sélectionnez d’abord un article.',
    loadFailed: 'Impossible de charger le modèle d’étiquette.',
  },
} as const;
